import { Card, Button } from "../primitives/index";
import { useTranslation } from "../../hooks/useTranslation";
import { useEffect, useState } from "react";
import ThreeDotsLoading from "../primitives/ThreeDotsLoading";
import { catchErrorParse } from "../../ErrorUtility";
import { Accordion } from "../primitives";

export default function ConfirmPayment({ onYesInc, onYesDec, onNo, onClose, loading, total, prevTotal, stripeCustomerId, newSubscriptionItem, currentSubscriptionItem, url, post }) {
    const t = useTranslation();
    const [invoicePreview, setInvoicePreview] = useState(null);

    useEffect(() => {
        if (stripeCustomerId) {
            const getInvoicePreview = async () => {
                const [invoice, error, errorCode, errorMessage] = await catchErrorParse(post, `${url}/webapp/invoices/preview`, {
                    stripeCustomerId,
                    newSubscriptionItem,
                    currentSubscriptionItem,
                });
                if (error) {
                    window.dispatchEvent(new CustomEvent('masterError', {
                        detail: {
                            code: errorCode,
                            message: errorMessage ? errorMessage : error.message || "Failed to load invoice preview."
                        }
                    }));
                }
                setInvoicePreview(invoice);
            }
            getInvoicePreview();
        }
    }, [stripeCustomerId]);

    const handleClick = () => {
        if(!total || !prevTotal) {
            window.dispatchEvent(new CustomEvent('masterError', {
                detail: {
                    message: "Invalid subscription values."
                }
            }));
            return;
        }
        if(total > prevTotal) {
            onYesInc();
        } else {
            onYesDec();
        }
    }

    const proration = total - prevTotal;

    return (
        <Card ctype="white" style={{ minWidth: '300px' }}>
            <Card.Header>
                <h2>{t('Confirm')}</h2>
            </Card.Header>
            <Card.Body>
                <p>{t('Are you sure you want to save these changes?')}</p>
                <p>Current monthly charge: <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(prevTotal / 100)}</b></p>
                <p>New monthly charge: <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total / 100)}</b></p>
                <hr />
                <Accordion>
                    <Accordion.Item>
                        <Accordion.Header style={{cursor: 'pointer'}}>{t('View Billing Details')}</Accordion.Header>
                        <Accordion.Body>
                            <div style={{padding: '10px', border: '1px solid #ccc', borderRadius: '5px'}}>
                                {invoicePreview ? (
                                    <div className="invoice-preview">
                                        <p>{proration >= 0 ? t('You will be charged:') : t('You will be refunded:')} <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Math.abs(invoicePreview.total / 100))}</b></p>
                                        {invoicePreview.lines?.data?.length > 0 && (
                                            <div className="invoice-line-items">
                                                {invoicePreview.lines.data.map((line, index) => (
                                                    <p key={index} className="invoice-line-item">
                                                        <small>
                                                            {line.description || t('Subscription adjustment')}:&nbsp;
                                                            <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(line.amount / 100)}</b>
                                                        </small>
                                                    </p>
                                                ))}
                                            </div>
                                        )}
                                        <p>Current Credit Balance: <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(invoicePreview.starting_balance / 100)}</b></p>
                                        <p>New Credit Balance: <b>{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(invoicePreview.ending_balance / 100)}</b></p>
                                    </div>
                                ) : (
                                    <ThreeDotsLoading />
                                )}
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
                <Button className="submit" onClick={handleClick} loading={loading}>{t('Confirm')}</Button> 
                <Button disabled={loading} onClick={onNo}>{t('Cancel')}</Button>
            </Card.Body>
        </Card>
    );
}